import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      
      <div className="max-w-lg mx-auto px-4 py-24">
        <Card className="card-dashboard">
          <CardContent className="py-12 text-center">
            <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
              <XCircle className="w-10 h-10 text-red-500" />
            </div>
            <h2 className="font-heading text-2xl font-bold mb-2">
              Paiement annulé
            </h2>
            <p className="text-muted-foreground mb-8">
              Votre paiement a été annulé. Aucun montant n'a été débité.
              Vous pouvez réessayer à tout moment.
            </p>
            <div className="flex flex-col gap-3">
              <Button 
                className="btn-primary"
                onClick={() => navigate('/listings')}
                data-testid="browse-listings-btn"
              >
                Parcourir les offres
              </Button>
              <Button 
                variant="outline"
                onClick={() => navigate('/seller')}
              >
                <ArrowLeft className="mr-2 w-5 h-5" />
                Retour au tableau de bord
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
